module.exports = __webpack_public_path__ + "static/img/A89.7be2179c.jpg";